import { Link } from "react-router-dom"
import { useEffect, useState } from "react";
import { useLocation } from 'react-router-dom';
//import { Dropdown, NavDropdown } from "react-bootstrap"
import navImg from '../assets/image.png'
import NavbarLine from "./NavbarLine";
import projects from '../components/Projects.json'
import { Skeleton } from 'primereact/skeleton';
import { CalendarIcon, ChartIcon, HomeIcon, InfoIcon, MapIcon } from "../assets/icons";

export default function Navbar() {

    const location = useLocation();

    const { pathname } = location;

    const splitLocation = pathname.split("/");

    const [projectList, setProjectList] = useState([]);

    const initData = () => {

        projects.sort((a, b) => {
            return a.projNum -b.projNum;
        })
        console.log(projects)
        setProjectList(projects.map((li) => {
            return <NavbarLine key={li.id} title={li.title} id={li.id} projNum={li.projNum} />
        }))
    }

    useEffect(() => {
        initData()
    }, [])

    return (
        <div>
            <nav className="navbar navbar-expand-lg" style={{ backgroundColor: 'white' }}>
                <div className="container justify-content-between">
                    <a className="navbar-brand">
                        <img src={navImg} style={{ height: "75px" }} alt="Johnson County Transportation Program" />
                        {/*<h3 className="d-none d-lg-inline ms-3" id="navbarH3" style={{ verticalAlign: "middle", color:"white" }}>Johnson County Transportation Bond Program</h3>*/}
                    </a>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                </div>
            </nav>
            <nav className="navbar navbar-expand-lg navbar-dark py-0 shadow-sm" style={{ backgroundColor: '#466580' }}>
                <div className="container">
                    <div className="collapse navbar-collapse" id="navbarCollapse">
                        <div className="navbar-nav fw-medium" style={{ fontSize: "20px" }}>
                            <li className="nav-item mx-1">
                                <Link className="nav-link" id={(splitLocation[1] === "" ? "active" : "")} to="/" ><HomeIcon />Home</Link>
                            </li>
                            {/*
                            <li className="nav-item mx-1">
                            <Link className="nav-link" id={(splitLocation[1] === "events" ? "active" : "")} to="/events">Events</Link>
                            </li>
                            */}
                            <li className="nav-item mx-1">
                                <Link className="nav-link" id={(splitLocation[1] === "projects" ? "active" : "")} to="/projects"><MapIcon />Project Map</Link>
                            </li>
                            {/*
                            <li className="nav-item mx-1"> <Link className="nav-link" id={(splitLocation[1] === "reports" ? "active" : "")} to="/reports">Reports</Link>
                            </li>
                            */}
                            <li className="nav-item dropdown pe-5" >
                                <div className="nav-link dropdown-toggle bold" id={(splitLocation[1] === "viewprojects" ? "active" : "notActive")} role="button" data-bs-toggle="dropdown">
                                    <InfoIcon />Projects
                                </div>
                                <ul className="dropdown-menu fw-bold" style={{ overflowY: "scroll", height: "600px" }}>
                                    {projectList}
                                </ul>
                            </li>
                        </div>
                    </div>
                </div>
            </nav>
        </div>
    )
}